const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

const isRailwayHost = (hostname) => hostname.endsWith(".up.railway.app");
const isLocalHost = (hostname) => ["localhost", "127.0.0.1", "0.0.0.0", "::1"].includes(hostname);

export const getApiOrigin = () => {
  if (typeof window === "undefined") {
    return configuredBackendUrl;
  }

  const current = window.location.origin;
  const currentHost = window.location.hostname;
  if (!configuredBackendUrl || isLocalHost(currentHost)) {
    return configuredBackendUrl || current;
  }

  try {
    const configured = new URL(configuredBackendUrl);
    const isRailwayCrossSubdomain =
      isRailwayHost(currentHost)
      && isRailwayHost(configured.hostname)
      && configured.hostname !== currentHost;

    // Railway subdomains are cross-site enough to be unreliable for cookie auth
    // on mobile browsers. Prefer the frontend's same-origin /api proxy there.
    if (isRailwayCrossSubdomain) {
      return current;
    }
  } catch {
    return current;
  }

  return configuredBackendUrl;
};

export const API_ORIGIN = getApiOrigin();
export const API_BASE = `${API_ORIGIN}/api`;

export const resolveMediaUrl = (value) => {
  if (!value || typeof value !== "string") return "";
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  if (value.startsWith("/")) return `${API_ORIGIN}${value}`;
  return value;
};
